const updates = [
  {
    time: '2小时前',
    title: '某知名导演新片开机现场曝光，阵容豪华引发期待',
    tag: '影视',
  },
  {
    time: '3小时前',
    title: '网红博主被前助理爆料拖欠工资，聊天记录流出',
    tag: '网红',
  },
  {
    time: '5小时前',
    title: '某综艺节目录制路透照曝光，飞行嘉宾身份引发猜测',
    tag: '综艺',
  },
  {
    time: '7小时前',
    title: '艺人工作室发表律师声明，否认近期网络不实传言',
    tag: '明星',
  },
  {
    time: '9小时前',
    title: '品牌方紧急更换代言人，新广告已连夜拍摄完成',
    tag: '品牌',
  },
  {
    time: '11小时前',
    title: '音乐节目总决赛结果引争议，评委打分遭质疑',
    tag: '音乐',
  },
  {
    time: '14小时前',
    title: '体育明星社交媒体发文暗示退役，粉丝集体泪崩',
    tag: '体育',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-2">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新快讯
            </h2>
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500"></span>
            </span>
          </div>
          <p className="text-sm text-foreground-600 mb-8">
            实时更新的吃瓜快讯，不错过任何风吹草动
          </p>
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden md:block"></div>
            <div className="space-y-4">
              {updates.map((item, i) => (
                <div key={i} className="flex gap-4 md:gap-6 items-start">
                  <div className="flex-shrink-0 hidden md:flex w-10 h-10 rounded-full bg-primary-500 items-center justify-center">
                    <i className="ri-time-line text-white text-sm"></i>
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 cursor-pointer hover:bg-background-50/80 transition-colors">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <span className="text-[10px] px-2 py-0.5 rounded font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}